import { translate } from "app/filters/i18nFilter";
import { simplePercentageFilter } from "app/filters/ngFilters";
import { addPercent } from "app/pages/activation/helpers/format";

import { PRECISION } from "../../Topics/constants";

import { MARKER_MAIN_HEIGHT } from "./constants";
import {
    TooltipContainer,
    TooltipMarker,
    TooltipMarkerName,
    StyledItemWrapper,
    StyledHeader,
    StyledGroup,
    StyledDomain,
    StyledShare,
} from "./styles";
import { DOMAIN, SHARE } from "./texts";

type TooltipDataSchema = {
    id: string;
    name: string;
    color: string;
    share: number;
    change: number;
}[];

type PieChartDetailedTooltipSchema = {
    data: TooltipDataSchema;
};

export const PieChartDetailedTooltip = ({ data }: PieChartDetailedTooltipSchema) => (
    <TooltipContainer>
        <StyledHeader>
            <StyledDomain>{translate(DOMAIN)}</StyledDomain>
            <StyledShare>{translate(SHARE)}</StyledShare>
        </StyledHeader>
        {data?.map(({ name, color, share, id }, idx) => {
            return (
                <StyledItemWrapper key={id || idx}>
                    <StyledGroup>
                        <TooltipMarker
                            height={MARKER_MAIN_HEIGHT}
                            width={MARKER_MAIN_HEIGHT}
                            backgroundColor={color}
                        />
                        <TooltipMarkerName>{translate(name)}</TooltipMarkerName>
                    </StyledGroup>

                    <TooltipMarkerName>{addPercent(simplePercentageFilter()(share, PRECISION))}</TooltipMarkerName>
                </StyledItemWrapper>
            );
        })}
    </TooltipContainer>
);
